import { IBreadcrumbItem } from '../model/breadcrumb.interface';


export const BREADCRUMB_RESET_STATE = 'BREADCRUMB_RESET_STATE';

export const BREADCRUMB_SET_INITIAL_CRUMB = 'BREADCRUMB_SET_INITIAL_CRUMB';
export const BREADCRUMB_ADD_CRUMB = 'BREADCRUMB_ADD_CRUMB';
export const BREADCRUMB_ADD_CRUMB_AND_SHRING = 'BREADCRUMB_ADD_CRUMB_AND_SHRING';
export const BREADCRUMB_SHRINK_TO_CRUMB_FROM_START = 'BREADCRUMB_SHRINK_TO_CRUMB_FROM_START';

export const BREADCRUMB_SET_SELECTED_CRUMB = 'BREADCRUMB_SET_SELECTED_CRUMB';

// ------------------------------------------------------------------------------------------------
// action creators
// ------------------------------------------------------------------------------------------------

export function breadcrumbResetState(index: number) {
   return { type: BREADCRUMB_RESET_STATE, payload: {index: index}};
}

export function breadcrumbSetInitialCrumb(jsObj: IBreadcrumbItem, index: number) {
   return { type: BREADCRUMB_SET_INITIAL_CRUMB, payload: {object: jsObj, index: index}};
}

export function breadcrumbAddCrumb(jsObj: IBreadcrumbItem, index: number) {
   return { type: BREADCRUMB_ADD_CRUMB, payload: {object: jsObj, index: index}};
}
export function breadcrumbAddCrumbAndShrink(jsObj: IBreadcrumbItem, index: number) {
   return { type: BREADCRUMB_ADD_CRUMB_AND_SHRING, payload: {object: jsObj, index: index}};
}

export function breadcrumbShrinkToCrumbFromStart(value: any, index: number) {
   return { type: BREADCRUMB_SHRINK_TO_CRUMB_FROM_START, payload: {object: value, index: index}};
}

export function breadcrumbSetSelectedCrumb(jsObj: IBreadcrumbItem, index: number) {
   return { type: BREADCRUMB_SET_SELECTED_CRUMB, payload: {object: jsObj, index: index}};
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/components/breadcrumb/store/actions.ts